import styled from "styled-components";

export const Container = styled.div`
  width: 100vw;
  min-height: 100vh;
  background: #fff;
`;

export const Content = styled.div`
  width: 90%;
  max-width: 1100px;
  margin: 50px auto;

  .ui.dropdown .menu .item {
    display: flex;
  }

  .ui.form .fields {
    justify-content: space-between;

    div {
      width: 500px;
    }
  }
`;

export const Title = styled.h1`
  width: 100%;
  margin: 0px 0px 15px 0px;
  padding: 0px;
  color: #000000;
  font-size: 28px;
  font-family: sans-serif;
  font-weight: 600;
  border-bottom: 1px solid rgba(34, 36, 38, 0.15);
  display: inline-block;
`;
